import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AppIcons } from '../../../shared/app.icons';
import { AppSettings } from '../../../shared/app.settings';
import { MITableComponent } from '../../../shared/components/mi-table/mi-table.component';
import type { Country } from '../../../shared/models/country';
import type { Language } from '../../../shared/models/language';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../shared/services/entity.service';
import type { EntityCountsResponse, EntityList } from '../../models/entity.models';

import { TranslateModule } from '@ngx-translate/core';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import { ModuleHeaderComponent } from '../../../shared/components/module-header/module-header.component';
import { ConfigService } from '../../../shared/services/config.service';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { ListResponse } from '../../models/listResponse.models';
import { ToastModule } from 'primeng/toast';
// import { ManageZonesService } from 'app/modules/manage-zones/services/manage-zones.service';

@Component({
  selector: 'app-products-list',
  standalone: true,
  imports: [BreadcrumbModule, ModuleHeaderComponent, TabViewModule, TranslateModule, MITableComponent, MITableComponent, AccessProviderDirective, ToastModule],
  templateUrl: './products-list.component.html',
  styleUrl: './products-list.component.scss'
})
export class ProductsListComponent implements OnInit {
  @ViewChild('uploader', { static: true }) uploader: ElementRef<HTMLElement>;
  @ViewChild(MITableComponent) tableRef: MITableComponent;

  miIcons = AppIcons;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns = [];
  cols = [];
  moduleName = 'product';
  filterList;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels = {};
  filterAttributeLabels = {};
  listColumns: any;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: AppSettings.PRODUCT_STATUS.UNARCHIVE
  };
  routePath: MenuItem[] = [];
  deleteProductMsg: string;
  deleteProductHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: any[];
  isReady: boolean = false;
  attributeData: any;
  data;
  rowItems: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader;
  reviewHeader: any;
  btnUpdate: any;
  entityCreatedAtAttributeId;
  regionGeofences: any = [];
  zoneIds: any = [];
  isEntity = true;
  productStatusAttributeId: string;
  showImportExportBtn: boolean = false;
  currentRowId;

  constructor(private productService: EntityService,
    private cs: CommonBindingDataService, private confirmationService: ConfirmationService,
    private router: Router, private messageService: MessageService, private actRoute: ActivatedRoute,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService, private permissionAccessService: PermissionAccessService,
    private cd: ChangeDetectorRef, private loaderService: LoaderService,
    private storageService: StorageService,
    // private manageZonesService: ManageZonesService
  ) { }



  ngOnInit() {
    this.initializeLabels();
    this.initializeRowItems();
    // this.initializeBulkSelectionsItems();
    this.initializeModuleHeaderSecondaryBtnMenuItems();
    this.initializeOtherVariablesAndAPI();
    this.getData();
    this.getMetaData();
    this.restoreActiveTab();
    this.handleUrlParams();
  }

  getMetaData() {
    this.getEntityCount();
    const payload = this.getMultiApiPayload();
    this.metaDataService.metaDataMultipleApi(payload).subscribe((res) => {
      const advancedFilter = JSON.parse(res.advancedFilter.responseBody);
      if (advancedFilter) {
        this.setVehicleFilterView(advancedFilter);
      }

      // const bulkUpdate = JSON.parse(res.bulkUpdate.responseBody);

      const sort = JSON.parse(res.sort.responseBody);
      const entityCreatedAt = sort.tabs[0].groups[0].fields.find(field => field.attributeCode === AppSettings.ENTITY_CREATED_AT);
      this.entityCreatedAtAttributeId = entityCreatedAt.attributeId;
      if (this.entityCreatedAtAttributeId) {
        // this.entityData.defaultSortColumn = this.entityCreatedAtAttributeId;
        this.entityData.defaultSortType = AppSettings.DESC_SORT_ORDER;
      }

      const defaultTableView = JSON.parse(res.defaultTableView.responseBody);
      if (defaultTableView) {
        this.setProductTableView(defaultTableView);
      }
      this.cs.applyFilterToColumn(defaultTableView, sort)
    });
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PRODUCT}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.ADVANCED_FILTER,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PRODUCT}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_SORT_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.SORT,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      // {
      //   url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PRODUCT}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.BULK_UPDATE_VIEW}`,
      //   inputBody: '',
      //   method: 'GET',
      //   outputKey: AppSettings.META_OUTPUT_KEY.BULK_UPDATE,
      //   headers: this.restApiService.getHeaderForMultipleAPI()
      // },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PRODUCT}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.DEFAULT_TABLE_VIEW,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
    ]
  }

  private initializeRowItems() {
    const isEdit = this.permissionAccessService.hasAccess('PRODUCTS', '', 'ALL', 'EDIT');
    const isDelete = this.permissionAccessService.hasAccess('PRODUCTS', '', 'ALL', 'DELETE');
    const isArchive = this.permissionAccessService.hasAccess('PRODUCTS', '', 'ALL', 'ARCHIVE');
    const isActivate = this.permissionAccessService.hasAccess('PRODUCTS', '', 'ALL', 'ACTIVATE');
    this.rowItems = [
      ...(isEdit ? [{
        label: this.cs.getLabel('product.lbl_edit'),
        icon: `${AppIcons.EDIT_2} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'edit',
        command: () => {
          this.update();
        }
      }] : []),
      ...(isArchive ? [{
        label: this.cs.getLabel('product.lbl_archive_dialog'),
        icon: `${AppIcons.ARCHIVE} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'archive',
        command: () => {
          this.onUpdateActionStatus('ARCHIVE');
        }
      }] : []),
      ...(isArchive ? [{
        label: this.cs.getLabel('product.lbl_unarchive'),
        icon: `${AppIcons.BOOKING_DEDICATED} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'unarchive',
        command: () => {
          this.onUpdateActionStatus('UNARCHIVE');
        }
      }] : []),
      ...(isActivate ? [{
        label: this.cs.getLabel('product.lbl_activate'),
        icon: `${AppIcons.CIRCLE_CHECKED} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'active',
        command: () => {
          this.onUpdateStatus('Active', this.cs.getLabel('product.lbl_activate'));
        }
      }] : []),
      ...(isActivate ? [{
        label: this.cs.getLabel('product.lbl_deactivate'),
        icon: `${AppIcons.ACTIVATE} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'deactive',
        command: () => {
          this.onUpdateStatus('Inactive', this.cs.getLabel('product.lbl_deactivate'));
        }
      }] : []),
      { separator: true },
      ...(isDelete ? [{
        label: this.cs.getLabel('product.lbl_delete'),
        icon: `${AppIcons.BASIC_TRAY} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'delete',
        command: () => {
          this.onDeleteProduct();
        }
      }] : []),
    ];
  }

  onUpdateStatus(status, acceptLabelText) {
    const isActive = status === 'Active';
    this.confirmationService.confirm({
      header: this.cs.getLabel(isActive ? 'product.lbl_activate_confirmation' : 'product.lbl_deactivate_confirmation'),
      message: this.cs.getLabel(isActive ? 'product.msg_activate_confirmation' : 'product.msg_deactivate_confirmation'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'bg-white text-color cancel',
      acceptButtonStyleClass: 'bg-red-500 delete',
      acceptLabel: acceptLabelText,
      rejectLabel: this.cs.getLabel('lbl_cancel'),
      accept: () => {

        const productData = {
          forTenantCode: this.configService.getForTenantCode(),
          entityCode: this.moduleName,
          countryCode: this.country[0].countryCode,
          languageCode: this.language?.[0]?.langCode || 'en',
          data: [{
            attributeId: this.productStatusAttributeId,
            attributeValue: status
          }],
          relationshipData: [],
          viewCode: AppSettings.VIEW_CODE.STATUS_UPDATE_VIEW,
        };

        this.productService.saveAttributeData(productData.entityCode, this.currentRow.id, productData).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.cs.getLabel('product.lbl_activate_successfully'),
            });
            setTimeout(() => {
              this.searchEntity();
              this.getEntityCount();
            }, 300);
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: this.cs.getLabel('product.lbl_failed_status'),
              detail: this.cs.getLabel('product.lbl_failed_status')
            });
          }
        });
      },
      reject: () => {
      }
    });
  }

  onUpdateActionStatus(status) {
    const isArchive = status === 'ARCHIVE';
    this.confirmationService.confirm({
      header: this.cs.getLabel(isArchive ? 'product.lbl_archive_confirmation' : 'product.lbl_unarchive_confirmation'),
      message: this.cs.getLabel(isArchive ? 'product.msg_archive_confirmation' : 'product.msg_unarchive_confirmation'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'bg-white text-color cancel',
      acceptButtonStyleClass: 'bg-red-500 delete',
      acceptLabel: isArchive ? this.cs.getLabel('product.lbl_archive_dialog') : this.cs.getLabel('product.lbl_unarchive_dialog'),
      rejectLabel: this.cs.getLabel('lbl_cancel'),
      accept: () => {
        const requestBody = {
          forTenantCode: this.configService.getForTenantCode(),
          countryCode: AppSettings.HEADER_COUNTRY_CODE,
          entityCode: AppSettings.ENTITY_CODE.PRODUCT,
          actionStatus: status
        };

        this.productService.updateStatus(this.currentRow.id, requestBody).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: status === 'ARCHIVE' ?
                this.cs.getLabel('product.lbl_product_archived_successfully') :
                this.cs.getLabel('product.lbl_product_unarchived_successfully')
            });
            setTimeout(() => {
              this.searchEntity();
              this.getEntityCount();
            }, 300);
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: status === 'ARCHIVE' ?
                this.cs.getLabel('product.lbl_product_archive_failed') :
                this.cs.getLabel('product.lbl_product_unarchive_failed')
            });
          }
        });
      },
      reject: () => {
      }
    });
  }



  private openBulkUpdateDialog() {
    this.showBulkUpdateDialog = false;
    this.cd.detectChanges();
    setTimeout(() => {
      this.showBulkUpdateDialog = true;
      this.cd.detectChanges();
      this.tableRef.showBulkRowDialog();
    }, 0);
  }

  handleBulkUpdate() {
    this.visible = true;
    this.showBulkUpdateDialog = true;
  }

  handleBulkPrint() {
    this.visiblePrintLabel = true;
  }

  private initializeModuleHeaderSecondaryBtnMenuItems() {
  }

  downloadImportTemplate() {
    this.productService.downloadImportTemplate(AppSettings.ENTITY_CODE.PRODUCT).subscribe(result => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result);
      a.download = 'Import Template.xlsx';
      a.click();
    },
      () => {
        // Handle download error
      });
  }

  downloadImportGuide() {
    this.productService.downloadImportGuide(AppSettings.ENTITY_CODE.PRODUCT).subscribe(result => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result);
      a.download = 'Import Guide.xlsx';
      a.click();
    },
      () => {
        // Handle download error
      });
  }

  private initializeLabels() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.bulkUpdateHeader = this.cs.getLabel('lbl_update_vehicles');
    this.reviewHeader = this.cs.getLabel('lbl_review_vehicles');
    this.btnUpdate = this.cs.getLabel('btn_update_vehicles2');
    this.routePath = [{ label: this.cs.getLabel('product.lbl_product'), routerLink: 'products/list' }];
  }

  private initializeOtherVariablesAndAPI() {
    this.btnLabel = this.cs.getLabel('product.add_product');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.deleteProductMsg = this.cs.getLabel('product.message.confirm_delete_msg');
    this.deleteProductHeaderMsg = this.cs.getLabel('product.message.confirm_delete_header');
  }



  public onChange(event) {
    for (const file of event.target.files) {
      if (file) {
        if (file.size > AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.cs.getLabel('err_file_size_exceed_msg') });
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append('forTenantCode', this.configService.getForTenantCode());
          formData.append('entityCode', AppSettings.ENTITY_CODE.PRODUCT);
          formData.append('viewCode', AppSettings.VIEW_CODE.EXCEL_IMPORT_VIEW);
          this.cs.importEntity(formData, AppSettings.ENTITY_CODE.PRODUCT).subscribe(() => {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('lbl_file_uploaded_successfully') });
          })
        }
      }
    }
  }

  getAttributeData() {
    this.productService.getAttributeDefinition(AppSettings.ENTITY_CODE.PRODUCT, AppSettings.VIEW_CODE.BULK_UPDATE_VIEW).subscribe(res => {
      if (res) {
        this.setVehicleView(res);
      }
    });
  }

  setVehicleView(res) {
    this.attributeData = res;
    this.isLoading = false;
    this.filterFieldsArray = res.tabs[0].groups[0].fields;
    this.filterFieldsArray.forEach(element => {
      switch (element.attributeCode) {
        case 'vehicle_type':
          element.attributeValue = 'Type';
          element.isDisable = false;
          break;
        case 'vehicle_status':
          element.attributeValue = 'Status';
          element.isDisable = false;
          break;
      }
    });

  }

  setCurrentRowData(event) {
    this.currentRow = event;
    this.currentRowId = event.id;
    if (event.deleted) {
      this.rowItems.forEach(item => {
        if (!item.separator) {
          item.disabled = true;
        }
      });
      return;
    }

    this.rowItems.forEach(item => {
      switch (item.value) {
        case 'archive':
          item.disabled = event.actionStatus === 'ARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'unarchive':
          item.disabled = event.actionStatus !== 'ARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'active':
          item.disabled = event.product_status.Active === 'Active' || event.actionStatus === 'DELETED';
          break;
        case 'deactive':
          item.disabled = event.product_status.Inactive === 'Inactive' || event.actionStatus === 'DELETED';
          break;
        case 'edit':
          item.disabled = event.actionStatus == 'ARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'delete':
          item.disabled = event.actionStatus === 'DELETED';
          break;
      }
    });
  }

  onDeleteProduct() {
    this.confirmationService.confirm({
    header:  this.deleteProductHeaderMsg,
    message: this.deleteProductMsg,
    acceptIcon: 'none',
    rejectIcon: 'none',
    rejectButtonStyleClass: 'bg-white text-color cancel',
    acceptButtonStyleClass: 'bg-red-500 delete',
    acceptLabel: this.cs.getLabel('lbl_delete'),
    rejectLabel: this.cs.getLabel('lbl_cancel'),
    accept: () => {
      const requestBody = {
        forTenantCode: this.configService.getForTenantCode(),
        countryCode: AppSettings.HEADER_COUNTRY_CODE,
        entityCode: AppSettings.ENTITY_CODE.PRODUCT,
        entityIds: [this.currentRowId]
      };

      this.productService.deleteEntityActionStatus(requestBody).subscribe({
        next: () => {
          this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'success');
          setTimeout(() => {
            this.searchEntity();
            this.getEntityCount();
          }, 300);
        },
        error: () => {
          this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'error');
        }
      });
    }
  });
  }

  update() {
    this.onUpdateVehicle(this.currentRow.id);
  }

  getTableView() {
    this.productService.getAttributeDefinition(AppSettings.ENTITY_CODE.PRODUCT, AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW, false).subscribe(res => {
      if (res) {
        this.setProductTableView(res);
      }
    });
  }

  setProductTableView(res) {
    this.isLoading = false;
    this.data = res;
    this.productStatusAttributeId = res.tabs[0].groups[0].fields.find(field => field.attributeCode === 'product_status')?.attributeId;

    this.attributeLabels = this.cs.getAttributeLabels(this.data);
    this.allColumns = this.cs.getColumns(this.data).filter(column =>
      !['entity_created_at'].includes(column.attributeCode)
    );

    this.searchEntity();
    this.allColumns?.forEach((key, index) => {
      this.allColumns[index] = key;
      this.allColumns[index].field = key.attributeCode;
      this.allColumns[index].header = this.cs.getLabelValue(
        `product` + `.fields.${key.attributeCode}.label`,
        this.attributeLabels,
        key.attributeCode
      );
    });
    this.filterAvailableColumns = _.clone(this.allColumns);
  }


  getFilterView() {
    this.productService.getAttributeDefinition(AppSettings.ENTITY_CODE.PRODUCT, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(filterResponse => {
      if (filterResponse) {
        this.setVehicleFilterView(filterResponse);
      }
    });
  }

  setVehicleFilterView(filterResponse) {
    this.filterAttributeLabels = this.cs.getAttributeLabels(filterResponse);
    this.filterList = this.cs.getColumns(filterResponse);
    this.filterList = _.sortBy(this.filterList, 'attributeIndex');
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView(),
      filterViewDate: this.getFilterView(),
      getEntityCount: this.getEntityCount()
    })
  }

  onSortData(sortColumnDetails) {
    this.entityData.defaultSortColumn = sortColumnDetails.attributeId;
    this.entityData.defaultSortType = (sortColumnDetails.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }

  searchEntity() {
    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.loaderService.hide();
    this.productService.searchEntity(AppSettings.ENTITY_CODE.PRODUCT, this.entityData, false).subscribe((res: ListResponse) => {
      this.listColumns = res?.data[0]?.values;
      this.pagination = res?.pagination;
      this.totalRecords = res?.count;
      this.tableData = [];
      res.data?.forEach((data: any) => {
        this.tableData.push({
          id: data.id,
          actionStatus: data?.actionStatus || '',
          ...data.values,
        });
      });
      this.loaderService.hide();
    })
  }


  onAddProduct() {
    this.router.navigate(['app/products/add-product',]);
  }

  getLabel(params) {
    return `${params}hi`;
  }

  onRowClicked() {
    // Row click handler
  }

  onActionBtnClicked() {
    // Action button click handler
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
  }

  onConfirmDelete() {
  }


  onVehicleDelete(event) {
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      countryCode: AppSettings.HEADER_COUNTRY_CODE,
      entityCode: AppSettings.ENTITY_CODE.PRODUCT,
      entityIds: [
        event
      ]
    };
    this.productService.deleteEntityActionStatus(requestBody).subscribe({
      next: () => {
        this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'success');
        setTimeout(() => {
          this.searchEntity();
          this.getEntityCount();
        }, 300);
      },
      error: () => {
        this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'error');
      }
    })
  }

  onUpdateVehicle(vehicleId) {
    this.router.navigate([`app/products/add-product/${vehicleId}`]);
  }


  onRowSelect(event) {
    if (event.type === 'row') {
      this.storageService.setItem('productActiveIndex', this.activeIndex);
      const tabParam = this.getTabParamFromIndex(this.activeIndex);
      this.router.navigate([`app/products/product-details/${event.data.id}`], {
        queryParams: { fromTab: tabParam }
      });
      this.productService.entityCurrentRow.next(event.data);
    }
  }


  onFilterValueChange(event) {
    const vData = event;
    this.entityData.filters = [];
    for (const [key, value] of Object.entries(vData)) {
      const attributeValue = value;
      if (attributeValue) {
        this.entityData.filters.push({
          attributeCode: key,
          attributeValue
        });
      }
    }
    this.entityData.filters = _.filter(_.uniq(this.entityData.filters, (item) => {
      if (item.attributeValue.length > 0) {
        return item.attributeCode;

      }
    }), (element) => {
      if (element.attributeValue.length > 0) {
        return true;
      }
      return false;
    });
    this.entityData.offset = event.first;
    this.entityData.filters = this.cs.mapAttributeIds(this.entityData.filters, this.filterList, 'filter');
    this.searchEntity();
  }


  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  getEntityCount() {
    const country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const entityCountPayload = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: AppSettings.ENTITY_CODE.PRODUCT,
      countryCode: <string>country[0].countryCode,
    };

    this.productService.getEntityCount(AppSettings.ENTITY_CODE.PRODUCT, entityCountPayload, false).subscribe((res: EntityCountsResponse) => {
      if (res?.counts) {
        res.counts.ALL = res.counts.ALL - (res.counts.DELETED + res.counts.ARCHIVE);
      }
      this.entityCount = res;
    })
  }

  tabViewChange(event) {
    this.activeIndex = event.index;
    this.storageService.setItem('productActiveIndex', event.index);
    this.updateUrlWithTab(event.index);
    switch (event.index) {
      case 0:
        this.entityData.actionStatus = AppSettings.PRODUCT_STATUS.UNARCHIVE;
        this.entityData.deleted = AppSettings.DELETED_TYPE.ONLY_NON_DELETED;
        this.entityData.filters = [];
        this.tableRef?.clearFilter();
        this.searchEntity();
        break;
      case 1:
        this.entityData.actionStatus = AppSettings.PRODUCT_STATUS.ARCHIVE;
        this.entityData.deleted = AppSettings.DELETED_TYPE.ONLY_NON_DELETED;
        this.entityData.filters = [];
        this.tableRef?.clearFilter();
        this.searchEntity();
        break;

      case 2:
        this.entityData.actionStatus = AppSettings.PRODUCT_STATUS.DELETED;
        this.entityData.deleted = AppSettings.DELETED_TYPE.ONLY_DELETED;
        this.entityData.filters = [];
        this.tableRef?.clearFilter();
        this.searchEntity();
        break;

      default:
        break;
    }
    if (event.index === 0 || event.index === 1 || event.index === 2) {
      this.showBulkUpdateDialog = false;
    }
  }

  private restoreActiveTab() {
    const savedIndex = this.storageService.getItem('productActiveIndex');
    if (savedIndex !== null && savedIndex !== undefined) {
      this.activeIndex = parseInt(savedIndex);
      this.tabViewChange({ index: this.activeIndex });
    }
  }

  private handleUrlParams() {
    this.actRoute.queryParams.subscribe(params => {
      const tabParam = params.tab;
      if (tabParam) {
        const tabIndex = this.getTabIndexFromParam(tabParam);
        if (tabIndex !== -1 && tabIndex !== this.activeIndex) {
          this.activeIndex = tabIndex;
          this.tabViewChange({ index: this.activeIndex });
        }
      }
    });
  }

  private getTabIndexFromParam(tabParam: string): number {
    switch (tabParam.toLowerCase()) {
      case 'all':
        return 0;
      case 'archive':
        return 1;
      case 'deleted':
        return 2;
      default:
        return -1;
    }
  }

  private updateUrlWithTab(tabIndex: number) {
    const tabParam = this.getTabParamFromIndex(tabIndex);
    if (tabParam) {
      this.router.navigate([], {
        relativeTo: this.actRoute,
        queryParams: { tab: tabParam },
        queryParamsHandling: 'merge'
      });
    }
  }

  private getTabParamFromIndex(tabIndex: number): string {
    switch (tabIndex) {
      case 0:
        return 'all';
      case 1:
        return 'archive';
      case 2:
        return 'deleted';
      default:
        return '';
    }
  }

  onBulkDataUpdateEvent() {
  }

  onBulkDataDeleteEvent(event) {
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      countryCode: AppSettings.HEADER_COUNTRY_CODE,
      entityCode: AppSettings.ENTITY_CODE.PRODUCT,
      entityIds: event
    };
    this.productService.deleteEntityActionStatus(requestBody).subscribe({
      next: () => {
        this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'success');
        setTimeout(() => {
          this.searchEntity();
          this.getEntityCount();
        }, 300);
      },
      error: () => {
        this.cs.onDisplayMessage(this.data, 'product', AppSettings.MSG_ACTION.DELETE, 'error');
      }
    });
  }
}
